import { action } from 'satcheljs/lib/legacy';
export default action('removeMentionTuple')(function removeMentionTuple(viewState, atMentionId, targetRecipient) {
    viewState.atMentionTuples[atMentionId] = targetRecipient;
});
//# sourceMappingURL=addMentionTuple.js.map